<div class="fixed inset-0 z-9999" (click)="closeModal()">
  <div class="absolute rounded-2xl backdrop-blur-2xl bg-white/95 border border-gray-200
              shadow-[0_8px_32px_rgba(0,0,0,0.15)] min-w-72 w-1/4 z-50 flex flex-col overflow-hidden" [ngStyle]="{
      top: currentTop + 'px',
      left: currentLeft + 'px',
      borderLeftColor: entry.color,
      borderLeftWidth: '4px'
    }" [class.cursor-grabbing]="dragging" (click)="$event.stopPropagation()">

    <!-- Header with Drag Handle -->
    <div class="flex items-center px-4 py-3 bg-gray-50 border-b border-gray-200 cursor-grab select-none"
      [class.cursor-grabbing]="dragging" (mousedown)="startDrag($event)">
      <div class="flex items-center gap-2 flex-1">
        <div [style.background]="entry.color" class="w-3 h-3 rounded-full shadow-sm flex-shrink-0"></div>
        <span class="text-sm font-semibold text-gray-700 truncate">{{ entry.projectName }}</span>
      </div>
      <div class="flex items-center gap-1">
        <!-- Drag indicator -->
        <div class="text-gray-400 mr-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
          </svg>
        </div>
        <button (click)="closeModal(); $event.stopPropagation()" (mousedown)="$event.stopPropagation()" class="w-7 h-7 rounded-md text-gray-400 hover:bg-red-100 hover:text-red-500
                       cursor-pointer text-sm transition-all duration-200 flex items-center justify-center">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto px-4 py-4 bg-white/60">
      @if (entry) {
      @if (isLocked) {
      <div class="flex items-center gap-2 mb-3 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200">
        <svg class="w-4 h-4 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
        </svg>
        <span class="text-xs font-medium text-amber-700">Entrée validée — lecture seule</span>
      </div>
      }
      <div class="flex flex-col gap-4">
        <!-- CRM Task badge (editable) -->
        @if (isCrmTask) {
        <div class="border border-blue-200 rounded-lg overflow-hidden bg-blue-50/50">
          <div class="flex items-center justify-between px-3 py-1.5 bg-blue-50 border-b border-blue-100">
            <label class="text-xs font-semibold text-blue-500 uppercase tracking-wide">CRM Task</label>
            @if (!isLocked) {
            <button type="button" (click)="openCrmPicker(); $event.stopPropagation()"
              class="text-xs font-medium text-blue-500 hover:text-blue-700 transition-colors cursor-pointer">
              {{ showCrmPicker ? 'Cancel' : 'Change' }}
            </button>
            }
          </div>
          @if (!showCrmPicker) {
          <div class="flex items-center gap-2 px-3 py-3">
            <svg class="w-4 h-4 text-blue-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            <span class="text-sm font-medium text-gray-800">{{ crmTaskLabel }}</span>
          </div>
          }
          @if (showCrmPicker) {
          <div (click)="$event.stopPropagation()">
            <div class="relative border-b border-blue-100">
              <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input type="text" [(ngModel)]="crmPickerSearch" (ngModelChange)="onPickerSearch()" placeholder="Search…"
                class="w-full pl-8 pr-3 py-2 text-xs bg-white focus:outline-none" />
            </div>
            <div class="max-h-40 overflow-y-auto">
              @if (filteredCrmTasks.length === 0) {
              <p class="text-center text-xs text-gray-400 py-4">No tasks found</p>
              }
              @for (task of filteredCrmTasks; track task.id) {
              <div (click)="selectCrmTask(task)"
                class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-blue-50 transition-colors border-b border-gray-50 last:border-0"
                [class.font-semibold]="task.name === crmTaskLabel">
                <span class="text-xs"
                  [class]="task.status === 'DONE' ? 'text-green-500' : task.status === 'IN_PROGRESS' ? 'text-blue-500' : 'text-gray-400'">
                  @if (task.status === 'DONE') { ✓ }
                  @else if (task.status === 'IN_PROGRESS') { ▶ }
                  @else { ○ }
                </span>
                <span class="text-xs font-medium text-gray-800 flex-1 truncate">{{ task.name }}</span>
              </div>
              }
            </div>
          </div>
          }
        </div>
        } @else {

        <!-- Project Select -->
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <label
            class="block px-3 py-1.5 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Project</label>
          @if(projects.length === 0) {
          <div class="w-full p-3 bg-white text-sm text-gray-400">
            Loading projects...
          </div>
          } @else {
          <select [(ngModel)]="selectedProjectId" (ngModelChange)="onProjectChange($event)"
            [disabled]="isLocked"
            class="w-full p-3 bg-white text-sm font-medium cursor-pointer focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0"
            [class.opacity-50]="isLocked" [class.cursor-not-allowed]="isLocked">
            <option value="">Select a project</option>
            @for(project of projects; track project.projectId){
            <option [value]="project.projectId">{{ project.projectName }}</option>
            }
          </select>
          }
        </div>

        <!-- Phase/Stage Select -->
        @if(selectedProjectId) {
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <label
            class="block px-3 py-1.5 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Phase</label>
          @if(filteredStages.length === 0) {
          <div class="w-full p-3 bg-white text-sm text-gray-400">
            No phases available
          </div>
          } @else {
          <select [(ngModel)]="selectedStageId" (ngModelChange)="onStageChange($event)"
            [disabled]="isLocked"
            class="w-full p-3 bg-white text-sm font-medium cursor-pointer focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0"
            [class.opacity-50]="isLocked" [class.cursor-not-allowed]="isLocked">
            <option value="">Select a phase</option>
            @for(stage of filteredStages; track stage.projectStageId){
            <option [value]="stage.projectStageId">{{ stage.stageName }}</option>
            }
          </select>
          }
        </div>
        }

        <!-- Task Select -->
        @if(selectedStageId) {
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <label
            class="block px-3 py-1.5 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Task</label>
          @if(filteredTasks.length === 0) {
          <div class="w-full p-3 bg-white text-sm text-gray-400">
            No tasks available
          </div>
          } @else {
          <select [(ngModel)]="selectedTaskId" (ngModelChange)="onTaskChange($event)"
            [disabled]="isLocked"
            class="w-full p-3 bg-white text-sm font-medium cursor-pointer focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0"
            [class.opacity-50]="isLocked" [class.cursor-not-allowed]="isLocked">
            <option value="">No task (phase only)</option>
            @for(task of filteredTasks; track task.id){
            <option [value]="task.id">{{ task.nameTask }}</option>
            }
          </select>
          }
        </div>
        }

        } <!-- end @if isCrmTask -->

        <!-- Billable + Approval Status (read-only for users) -->
        <div class="flex items-center gap-2">
          <!-- Billable (read-only) -->
          <div class="flex-1 flex items-center justify-between px-3 py-2 border border-gray-200 rounded-lg bg-gray-50">
            <span class="text-xs font-medium text-gray-500">Billable</span>
            @if (entry.billable ?? true) {
            <span class="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full">
              <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>Yes
            </span>
            } @else {
            <span class="inline-flex items-center gap-1 text-xs font-semibold text-gray-500 bg-gray-100 border border-gray-200 px-2 py-0.5 rounded-full">
              <span class="w-1.5 h-1.5 rounded-full bg-gray-400"></span>No
            </span>
            }
          </div>
          <!-- Approval Status (read-only) -->
          <div class="flex-1 flex items-center justify-between px-3 py-2 border border-gray-200 rounded-lg bg-gray-50">
            <span class="text-xs font-medium text-gray-500">Status</span>
            @if ((entry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
            <span class="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full">
              <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>Approved
            </span>
            } @else {
            <span class="inline-flex items-center gap-1 text-xs font-semibold text-gray-500 bg-gray-100 border border-gray-200 px-2 py-0.5 rounded-full">
              <span class="w-1.5 h-1.5 rounded-full bg-gray-400"></span>Draft
            </span>
            }
          </div>
        </div>

        <!-- Description -->
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <label
            class="block px-3 py-1.5 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Description</label>
          <textarea [(ngModel)]="entry.content" (blur)="entry.id && updateTimeEntry({ content: entry.content })"
            name="content" placeholder="Add a description..." rows="3"
            [readonly]="isLocked"
            class="w-full p-3 bg-white text-sm resize-y focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0"
            [class.opacity-50]="isLocked" [class.cursor-not-allowed]="isLocked">
            </textarea>
        </div>

        <!-- Time Range -->
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <label
            class="block px-3 py-1.5 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Time</label>
          <div class="flex items-center justify-center gap-3 p-3 bg-white">
            <!-- Start -->
            <div class="flex items-center gap-1.5">
              <input type="number" min="0" max="23" [ngModel]="getHour(entry.startTime)"
                (ngModelChange)="updateTimeFromSelects('start', +$event, getMinute(entry.startTime))"
                [disabled]="isLocked" class="time-input" [class.opacity-50]="isLocked" />
              <span class="text-gray-400 font-bold text-lg">:</span>
              <input type="number" min="0" max="59" [ngModel]="getMinute(entry.startTime)"
                (ngModelChange)="updateTimeFromSelects('start', getHour(entry.startTime), +$event)"
                [disabled]="isLocked" class="time-input" [class.opacity-50]="isLocked" />
            </div>
            <span class="text-gray-400 font-medium text-base px-1">→</span>
            <!-- End -->
            <div class="flex items-center gap-1.5">
              <input type="number" min="0" max="23" [ngModel]="getHour(entry.endTime)"
                (ngModelChange)="updateTimeFromSelects('end', +$event, getMinute(entry.endTime))"
                [disabled]="isLocked" class="time-input" [class.opacity-50]="isLocked" />
              <span class="text-gray-400 font-bold text-lg">:</span>
              <input type="number" min="0" max="59" [ngModel]="getMinute(entry.endTime)"
                (ngModelChange)="updateTimeFromSelects('end', getHour(entry.endTime), +$event)"
                [disabled]="isLocked" class="time-input" [class.opacity-50]="isLocked" />
            </div>


          </div>
        </div>

        <!-- Images Section -->
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <!--
            <label class="block px-3 py-1.5 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Images</label>
-->
          <div class="p-3 bg-white">
            <!--              @if((entry.imagePaths?.length ?? 0) > 0){
                <button class="mb-3 px-4 py-2 rounded-md text-sm font-medium bg-blue-50 text-blue-600
                               border border-blue-200 hover:bg-blue-500 hover:text-white hover:border-blue-500
                               transition-all duration-200 cursor-pointer w-full" (click)="toggleImages()">
                  {{ imagesLoaded ? 'Hide Images' : 'Show Images' }}
                </button>
              }-->
            <!--              @if(imagesLoaded){
                @for (img of imageUrls; track img.path) {
                  <div class="relative mt-2">
                    <img [src]="img.url" alt="Entry image" class="max-w-full rounded-lg shadow-sm border border-gray-200 cursor-pointer" (click)="toggleImages()" />
                    <button class="absolute top-2 right-2 w-6 h-6 rounded-md bg-rose-500 text-white hover:bg-rose-600
                                   text-xs cursor-pointer transition-all duration-200 flex items-center justify-center shadow-sm"
                      (click)="deleteImage(img.path); $event.stopPropagation()">
                      ✕
                    </button>
                  </div>
                }
              }-->
            <!--<div class="flex flex-col gap-2 mt-2">
                <div class="flex items-center gap-2">
                  <label for="entryFileInput"
                         class="px-3 py-2 rounded-md text-xs font-medium bg-gray-50 border border-gray-200
                                text-gray-700 cursor-pointer hover:bg-gray-100 transition-all">
                    Choose files
                  </label>
                  <input id="entryFileInput" type="file" accept="image/*" multiple (change)="onFilesSelected($event)" hidden/>
                  <span class="text-xs text-gray-500">
                    {{ selectedFiles.length > 0 ? selectedFiles.length + ' file(s)' : 'No files' }}
                  </span>
                </div>
                <button class="px-4 py-2 rounded-md text-sm font-medium text-white
                               bg-emerald-500 hover:bg-emerald-600 border border-emerald-600
                               transition-all duration-200 cursor-pointer shadow-sm" (click)="addImage()">
                  Upload Images
                </button>
              </div>-->
          </div>
        </div>
      </div>
      } @else {
      <div class="p-4 text-center text-sm text-gray-400">
        No details available
      </div>
      }
    </div>

    <!-- Footer -->
    <div class="shrink-0 border-t border-gray-200 px-4 py-3 bg-gray-50/80 flex justify-between items-center">
      <!-- Left: Delete or Lock badge -->
      @if (!isLocked) {
      <button (click)="deleteTimeEntry()" class="px-4 py-2 rounded-md text-sm font-medium text-white
                     bg-rose-500 hover:bg-rose-600 border border-rose-600
                     transition-all duration-200 cursor-pointer shadow-sm">
        Delete
      </button>
      } @else {
      <span class="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-amber-600 bg-amber-50 border border-amber-200 rounded-md">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
        </svg>
        Validée
      </span>
      }
      <!-- Right: Close -->
      <button (click)="closeModal()" class="px-4 py-2 rounded-md text-sm font-medium text-gray-600
                     bg-gray-100 hover:bg-gray-200 border border-gray-200
                     transition-all duration-200 cursor-pointer shadow-sm">
        Close
      </button>
    </div>
  </div>
</div>